export default "__VITE_ASSET__665f1522__"